import { Injectable } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { CoordinationResultsFormModel } from '../../models/coordination-results-form-model';
import {
    FormGroupType,
    NestedFormGroupType,
} from '../../../../../../core/models/form-group-type';
import { CoordinationResultStudyFormModel } from '../../models/coordination-result-study-form-model';

@Injectable({
    providedIn: 'root',
})
export class CoordinationResultsFormService {
    getFormDefinition(): FormGroup<
        NestedFormGroupType<CoordinationResultsFormModel>
    > {
        return new FormGroup<NestedFormGroupType<CoordinationResultsFormModel>>(
            {
                studies: new FormArray<
                    FormGroup<FormGroupType<CoordinationResultStudyFormModel>>
                >([]),
            },
        );
    }
}
